import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@sparefoot/react-core';
import { overwriteDisplayName } from '@sparefoot/react-core/tracking-lib';
import useLazyLoad from 'hooks/useLazyLoad';

const LazyImage = (props) => {
	const { src: originalSrc, lazyLoad, fetchPriority, ...rest } = props;
	const { displaySrc, getRef } = useLazyLoad(originalSrc, lazyLoad);

	return (
		<Image
			data-testid="lazy-image"
			{...rest}
			src={displaySrc}
			getRef={getRef}
			fetchPriority={fetchPriority}
		/>
	);
};

LazyImage.propTypes = {
	src: PropTypes.string,
	lazyLoad: PropTypes.bool,
	fetchPriority: PropTypes.oneOf(['high', 'low', 'auto']),
};

export const enhance = () => {
	const EnhancedImage = (props) => {
		if (props.fetchPriority === 'high' || !props.lazyLoad) {
			return <Image {...props} />;
		}
		return <LazyImage {...props} />;
	};
	EnhancedImage.propTypes = {
		src: PropTypes.string,
		lazyLoad: PropTypes.bool,
		fetchPriority: PropTypes.oneOf(['high', 'low', 'auto']),
	};
	return overwriteDisplayName('Image')(EnhancedImage);
};

export default enhance();
